import _ from 'lodash';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { ZalohyState, zalohyStoreBuilder } from '@/modules/components/zalohy/store/edit';
import { POLOZKY } from '@/modules/components/zalohy/constants';

import { NAME as name, CRUMB_LABEL_KEY as crumbLabel } from '../constants';
import { apiProvider } from '../api';

const zalohyStore = zalohyStoreBuilder(apiProvider);

export const store = editStoreBuilder(_.merge(
	zalohyStore,
	{
		name,
		apiProvider,
		crumbLabel,
		edit: {
			ZakazkaId: null as number | null,
			ZakzalohaId: null as number | null,
			ZakzalohaNr: null as number | null,
		},
		depTableSettings: {
			[POLOZKY]: {
				filter(state:ZalohyState) {
					return { ZakzalohaId: state.props.id };
				},
			},
		},
		props: {
			filter: {
				ZakazkaId: null as number | null,
				ZakazkaNr: null as number | null,
			},
		},
	},
));
